export const PRODUCTS_AND_SERVICES_DOMESTIC = [
  {
    route: '/products-and-services/parcel-delivery/uk/',
    title: 'See All UK Services',
  },
  {
    route: '/products-and-services/parcel-collection/',
    title: 'Parcel Collection',
  },
  {
    route: '/products-and-services/next-day-delivery/',
    title: 'Next Day Delivery',
  },
  {
    route: '/products-and-services/weekend-delivery/',
    title: 'Weekend Delivery',
  },
  {
    route: '/products-and-services/saturday-delivery/',
    title: 'Saturday Delivery',
  },
  {
    route: '/products-and-services/sunday-delivery/',
    title: 'Sunday Delivery',
  },
  {
    route: '/products-and-services/large-parcels/',
    title: 'Large Parcels',
  },
  {
    route: '/products-and-services/heavy-parcels/',
    title: 'Heavy Parcels',
  },
  {
    route: '/products-and-services/packaging-tips/',
    title: 'Packaging Tips',
  },
];
export const PRODUCTS_AND_SERVICES_INTERNATIONAL = [
  {
    route: '/products-and-services/international/',
    title: 'All International Services',
  },
  {
    route: '/products-and-services/parcel-delivery/france/',
    title: 'France',
  },
  {
    route: '/products-and-services/parcel-delivery/germany/',
    title: 'Germany',
  },
  {
    route: '/products-and-services/parcel-delivery/italy/',
    title: 'Italy',
  },
  {
    route: '/products-and-services/parcel-delivery/netherlands/',
    title: 'Netherlands',
  },
  {
    route: '/products-and-services/parcel-delivery/spain/',
    title: 'Spain',
  },
  {
    route: '/products-and-services/parcel-delivery/usa/',
    title: 'USA',
  },
  {
    route: '/products-and-services/parcel-delivery/ireland/',
    title: 'Ireland',
  },
  {
    route: '/products-and-services/parcel-delivery/canada/',
    title: 'Canada',
  },
  {
    route: '/products-and-services/parcel-delivery/australia/',
    title: 'Australia',
  },
  {
    route: '/products-and-services/customs-advice/',
    title: 'Customs Advice',
  },
  {
    route: '/products-and-services/ioss/',
    title: 'IOSS',
  },
  {
    route: '/products-and-services/parcel-delivery/northern-ireland/',
    title: 'Northern Ireland',
  },
];

export const PROHIBITED_LIST = {
  route: '/products-and-services/prohibited-items',
  title: 'Prohibited Goods',
};
